/** @jsx jsx */
/** @jsxfrag */
import React from 'react';
import { jsx } from '@emotion/react';
export var AppRecommendations = function AppRecommendations(_ref) {
  var children = _ref.children;
  return jsx(React.Fragment, null, children);
};